var _path, _path2, _path3, _path4, _circle, _rect, _path5, _circle2, _path6, _rect2, _rect3, _rect4, _rect5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect6, _rect7, _ellipse, _circle3, _circle4, _path20, _path21, _path22, _path23, _rect8, _rect9, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1044.53,
    height: 791.716,
    viewBox: "0 0 1044.53 791.716",
    xmlnxlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(-438 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(-115.33 -0.142)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_406-2505",
    "data-name": "Path 406",
    d: "M727.256,366.754c-11.134-18.414-24.327-38.076-44.989-44.089-23.927-6.963-48.507,6.87-69.356,20.52A2021.019,2021.019,0,0,0,433.051,475.7l.063.715,134.214-9.256c32.323-2.229,65.757-4.766,94.322-20.057,10.839-5.8,21.405-13.553,33.688-14.093,15.26-.671,28.566,9.987,39.023,21.122C796.216,520,814.115,620.727,883.51,678.6A2202.248,2202.248,0,0,0,727.256,366.754Z",
    transform: "translate(505.042 -51.854)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407-2506",
    "data-name": "Path 407",
    d: "M1139.035,913.705h-6.126Q1052.925,809.79,982.393,699.052q-49.257-77.261-93.622-157.513-2.613-4.725-5.212-9.465Q865.2,498.582,847.7,464.641q-15.5-30.051-30.3-60.45c-2.816-5.792-5.56-11.6-8.289-17.435-6.431-13.7-12.732-27.481-19.511-41-6.838-13.661-15-27.888-26.61-38.152a58.328,58.328,0,0,0-4.674-3.775,48.9,48.9,0,0,0-5.778-3.644c-.2-.116-.406-.218-.61-.334a39.728,39.728,0,0,0-15.853-4.573c-11.541-.755-22.183,4.021-32.2,9.218q-25.347,13.218-49.925,27.96A1053.966,1053.966,0,0,0,500.462,444.708l-.363.319A1060.655,1060.655,0,0,0,334.543,628.8c-1.466,2.091-4.921.087-3.44-2q8.71-12.347,17.784-24.418A1063.718,1063.718,0,0,1,502.058,438.045q9.516-8.275,19.25-16.317a1066.25,1066.25,0,0,1,99.923-73.371q15.94-10.343,32.243-20.063,10.8-6.467,21.747-12.674c9.233-5.226,18.51-10.394,27.946-15.229,9.247-4.762,19.061-9.03,29.63-9.189a44.21,44.21,0,0,1,21.834,5.313c.2.116.421.218.624.348a58.176,58.176,0,0,1,11.323,8.275c15.345,14.212,25.609,36.511,33.593,53.627q6.032,12.957,12.209,25.8,23.322,48.8,48.459,96.729,13.436,25.587,27.38,50.956c1.423,2.628,2.874,5.255,4.326,7.868q50.39,91.045,107.109,178.418C1044.556,787.695,1089.154,849.626,1139.035,913.705Z",
    transform: "translate(458.825 -65.229)",
    fill: "#e4e4e4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563-2507",
    "data-name": "Path 563",
    d: "M930.428,385.006s-7.043,16.363-5.386,18.7-20.3-7.792-20.3-7.792,7.043-16.363,7.043-18.311S930.428,385.006,930.428,385.006Z",
    transform: "translate(103.332 231.562)",
    fill: "#ffb9b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2320-2508",
    "data-name": "Path 2320",
    d: "M915.6,754.032s.622-13.027,13.366-11.513",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 6.379,
    cy: 6.379,
    r: 6.379,
    transform: "translate(1265.639 818.878)",
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 1.801,
    height: 12.604,
    transform: "translate(1270.979 835.998)",
    fill: "#090814"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2321-2509",
    "data-name": "Path 2321",
    d: "M482.565,371.062q0,4.785-.31,9.49a143.754,143.754,0,0,1-13.47,52.19c-.06.14-.13.27-.19.4-.36.76-.73,1.52-1.11,2.27a142.036,142.036,0,0,1-7.65,13.5,144.462,144.462,0,0,1-118.56,66.72l1.43,82.24,18.65-9.82,3.33,6.33-21.84,11.5,2.67,152.74.03,2.04-14.42,3.21.03-2.05,4.54-246.18a144.175,144.175,0,0,1-102-44.38c-.91-.94-1.81-1.91-2.69-2.87-.04-.04-.07-.08-.1-.11a144.768,144.768,0,0,1-26.34-40.76c.14.16.29.31.43.47a144.642,144.642,0,0,1,68.58-186.38c.5-.25,1.01-.49,1.51-.74a144.752,144.752,0,0,1,187.53,56.93c.88,1.48,1.73,2.99,2.55,4.51A143.852,143.852,0,0,1,482.565,371.062Z",
    transform: "translate(360.014 90)",
    fill: "#e5e5e5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 189.539,
    cy: 189.539,
    r: 189.539,
    transform: "translate(633.573 144.142)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322-2510",
    "data-name": "Path 2322",
    d: "M323.149,117.084C282,213.344,326.672,324.739,422.933,365.891a189.554,189.554,0,0,0,216.045-48.2c-41.147,96.263-152.54,140.944-248.8,99.8s-140.944-152.54-99.8-248.8a189.556,189.556,0,0,1,32.772-51.6Z",
    transform: "translate(360.014 90)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2323-2511",
    "data-name": "Path 2323",
    d: "M280.01,717.56l-19.36-5.43.04-2.08,5.8-315.28.29-15.72.01-.46,1.01-55.08,1.47-79.84v-.01l1-54.12h.53l1.02,58.63,1.33,76.31.95,54.15v.4l.04,2.23v.01l1.84,105.55.19,10.49,3.8,218.15Z",
    transform: "translate(553.359 144.142)",
    fill: "#090814"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 35.408,
    height: 9.373,
    transform: "translate(822.448 634.589) rotate(-27.766)",
    fill: "#090814"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 89.372,
    height: 2,
    transform: "translate(730.028 899.858)",
    fill: "#cbcbcb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 89.372,
    height: 2,
    transform: "translate(894.027 933.858)",
    fill: "#cbcbcb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 89.372,
    height: 2,
    transform: "translate(1149.027 907.858)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2324-2512",
    "data-name": "Path 2324",
    d: "M837.565,736.482V678.308S860.236,719.551,837.565,736.482Z",
    transform: "translate(626.864 86.365)",
    fill: "#f1f1f1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2325-2513",
    "data-name": "Path 2325",
    d: "M838.965,736.472,796.111,697.13S841.825,708.321,838.965,736.472Z",
    transform: "translate(360.014 90)",
    fill: "#f1f1f1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2326-2514",
    "data-name": "Path 2326",
    d: "M394.565,750.482V692.308S417.236,733.551,394.565,750.482Z",
    transform: "translate(360.014 90)",
    fill: "#f1f1f1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2327-2515",
    "data-name": "Path 2327",
    d: "M395.965,750.472,353.111,711.13S398.825,722.321,395.965,750.472Z",
    transform: "translate(360.014 90)",
    fill: "#f1f1f1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2328-2516",
    "data-name": "Path 2328",
    d: "M548.565,792.482v-72.34S576.757,771.428,548.565,792.482Z",
    transform: "translate(360.014 90)",
    fill: "#f1f1f1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2329-2517",
    "data-name": "Path 2329",
    d: "M550.306,792.469l-53.29-48.921S553.862,757.463,550.306,792.469Z",
    transform: "translate(360.014 90)",
    fill: "#f1f1f1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2330-2518",
    "data-name": "Path 2330",
    d: "M813.31,729.49l-.55,1.93-167.83-47.8L518.5,711.49,356.81,739.11l-.22-.06-76.58-21.49-19.36-5.43-59.13-16.6L152.2,706.52l-14.42,3.21-31.35,6.99-.43-1.95,31.81-7.09,14.36-3.2,49.41-11.01.24.06,58.87,16.52,19.28,5.41,76.94,21.6,161.2-27.53,126.88-27.97.25.06Z",
    transform: "translate(553.359 144.142)",
    fill: "#cbcbcb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2331-2519",
    "data-name": "Path 2331",
    d: "M706.4,175.579l12.795-10.233c-9.94-1.1-14.024,4.324-15.7,8.615-7.765-3.224-16.219,1-16.219,1l25.6,9.294a19.372,19.372,0,0,0-6.481-8.677Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2332-2520",
    "data-name": "Path 2332",
    d: "M236.4,171.579l12.795-10.233c-9.94-1.1-14.024,4.324-15.7,8.615-7.765-3.224-16.219,1-16.219,1l25.6,9.294a19.372,19.372,0,0,0-6.481-8.677Z",
    transform: "translate(1155.317 162.953)",
    fill: "#090814"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2333-2521",
    "data-name": "Path 2333",
    d: "M678.4,366.579l12.795-10.233c-9.94-1.1-14.024,4.324-15.7,8.615-7.765-3.224-16.219,1-16.219,1l25.6,9.294a19.372,19.372,0,0,0-6.481-8.677Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2334-2522",
    "data-name": "Path 2334",
    d: "M398.156,756.7l12.275,4.03,23.432-39.927-18.117-5.949Z",
    transform: "translate(547.437 139.618)",
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2336-2523",
    "data-name": "Path 2336",
    d: "M494.157,762.733h13.534l2.464-40.237-19.955.611Z",
    transform: "translate(554.548 144.142)",
    fill: "#ffb9b9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2338-2524",
    "data-name": "Path 2338",
    d: "M639.975,537.805l3.4-6.807,28.931,14.466-.851,5.956,5.531,7.233s9.36,5.106,7.658,22.124l-1.7,16.167-2.127,20.848,14.891,51.481,7.658,68.074,5.531,54.884-26.8-1.276-24.677-89.347-43.4,96.154L584.24,790.1l40.844-95.3,5.106-39.993s-3.4-21.273,12.764-35.739L640.4,611.41v-9.437l-8.509-45.022Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 1,
    height: 68.961,
    transform: "translate(998.231 725.372) rotate(-15.751)",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 41.695,
    height: 4.255,
    transform: "translate(1042.535 712.046) rotate(180)",
    fill: "#d6d6e3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 1.702,
    cy: 4.255,
    rx: 1.702,
    ry: 4.255,
    transform: "translate(1040.834 706.09)",
    fill: "#d6d6e3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 22.682,
    cy: 22.682,
    r: 22.682,
    transform: "translate(992.949 605.923) rotate(-61.337)",
    fill: "#ffb9b9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 20.066,
    cy: 20.066,
    r: 20.066,
    transform: "translate(968.959 548.669)",
    fill: "#090814"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2339-2525",
    "data-name": "Path 2339",
    d: "M603.546,476.586a20.067,20.067,0,1,0,39.143,8.229,20.067,20.067,0,0,1-39.143-8.229Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2340-2526",
    "data-name": "Path 2340",
    d: "M682.818,500.6a23.724,23.724,0,1,1-14.157-19.1c3.963-3.2,8.875-2.205,12.87,1.167,4.517,3.814,5.857,6.433,9.36,12.7C687.446,495.857,686.263,500.117,682.818,500.6Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2341-2527",
    "data-name": "Path 2341",
    d: "M599.444,568.812c.254,6.722.757,19.953.757,20.628,0,.712,10.031,21.48,14.364,30.419v0c.308.63.585,1.2.83,1.7a4.028,4.028,0,0,0,3.7,2.275l18.937-.34A4.036,4.036,0,0,0,642,619.569l2.112-83.315a2.06,2.06,0,0,0-2.058-2.112H617.634a5.491,5.491,0,0,0-4.941,3.1l-11.721,24.25a15.5,15.5,0,0,0-1.528,7.32Z",
    transform: "translate(360.014 90)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2342-2528",
    "data-name": "Path 2342",
    d: "M642.331,613.852a54.233,54.233,0,0,0,12.939-10.936,60.009,60.009,0,0,0,14.955-34.888c.963-11.072-1.234-19.3-6.53-24.463-6.732-6.559-15.894-5.606-16.281-5.562l-.41.046L640.8,543.3l1.757,2.076,5.555-4.7c1.7-.085,8.641-.1,13.712,4.856,4.667,4.565,6.584,12.054,5.7,22.258a57.309,57.309,0,0,1-14.208,33.237,52.654,52.654,0,0,1-12.29,10.44Z",
    transform: "translate(360.014 90)",
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 0.906,
    height: 33.78,
    transform: "matrix(0.201, -0.98, 0.98, 0.201, 966.918, 673.086)",
    fill: "#090814"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 52.695,
    height: 0.907,
    transform: "matrix(0.041, -0.999, 0.999, 0.041, 986.763, 676.77)",
    fill: "#090814"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2343-2529",
    "data-name": "Path 2343",
    d: "M599.444,568.812c.254,6.722.757,19.953.757,20.628,0,.712,10.031,21.48,14.364,30.419l-8.077-46.9a10.338,10.338,0,0,0-6.713-7.973,15.215,15.215,0,0,0-.331,3.826Z",
    transform: "translate(360.014 90)",
    fill: "#090814"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2344-2530",
    "data-name": "Path 2344",
    d: "M649.07,667.1a7.979,7.979,0,0,1,2.6-11.956l-1.642-18.16,10.792-3.689,1.958,25.677a8.022,8.022,0,0,1-13.7,8.128Z",
    transform: "translate(360.014 90)",
    fill: "#ffb7b7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2345-2531",
    "data-name": "Path 2345",
    d: "M642.006,557.5a12.45,12.45,0,0,1,8.422-12.742,11.309,11.309,0,0,1,7.113.006,12.448,12.448,0,0,1,8.433,11.849l.809,92.222-19.123.693Z",
    transform: "translate(360.014 90)",
    fill: "#f2f2f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_633-2532",
    "data-name": "Path 633",
    d: "M761.86,593.413s-10.248-.588-12.057-1.176-5.425,15.293,0,16.469,27.73,2.941,27.73,2.941,17.482-.588,16.276-5.294-24.716-14.116-24.716-14.116S766.08,586.354,761.86,593.413Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 258.477, 363.874)",
    fill: "#090814"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2346-2533",
    "data-name": "Path 2346",
    d: "M761.86,593.413s-10.248-.588-12.057-1.176-5.425,15.293,0,16.469,27.73,2.941,27.73,2.941,17.482-.588,16.276-5.294-24.716-14.116-24.716-14.116S766.08,586.354,761.86,593.413Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 334.789, 159.622)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking);
export default __webpack_public_path__ + "static/media/hiking.084df4eb0ef8f3894a5885f172bcc9fc.svg";
export { ForwardRef as ReactComponent };